import moment from "moment";

import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { es } from "date-fns/locale";

export const DateFilters = ({
  filters,
  setFilters,
  handleChangeDateDesde,
  handleChangeDateHasta,
}) => {
  return (
    <>
      <div
        className="btn-group"
        role="group"
        aria-label="Basic radio toggle button group"
      >
        <input
          type="radio"
          className="btn-check"
          name="btnradio"
          id="btnradio1"
          autoComplete="off"
          checked={filters.time === "year" && "checked"}
          onChange={() => setFilters({ ...filters, time: "year" })}
        />
        <label
          className="btn btn-outline-light"
          htmlFor="btnradio1"
          style={{ color: filters.time === "year" ? "#8E24AA" : "#595759" }}
        >
          Anual ({moment(filters.fecha_desde).format("YYYY")})
        </label>

        <input
          type="radio"
          className="btn-check"
          name="btnradio"
          id="btnradio2"
          autoComplete="off"
          checked={filters.time === "month" && "checked"}
          onChange={() => setFilters({ ...filters, time: "month" })}
        />
        <label
          className="btn btn-outline-light"
          htmlFor="btnradio2"
          style={{
            color: filters.time === "month" ? "#8E24AA" : "#595759",
          }}
        >
          Mensual (
          <span style={{ textTransform: "capitalize" }}>
            {moment(filters.fecha_desde).format("MMMM")}
          </span>{" "}
          {moment(filters.fecha_desde).format("YYYY")})
        </label>

        <input
          type="radio"
          className="btn-check"
          name="btnradio"
          id="btnradio3"
          autoComplete="off"
          checked={filters.time === "range" && "checked"}
          onChange={() => setFilters({ ...filters, time: "range" })}
        />
        <label
          className="btn btn-outline-light"
          htmlFor="btnradio3"
          style={{
            color: filters.time === "range" ? "#8E24AA" : "#595759",
          }}
        >
          Rango
        </label>
      </div>

      {filters.time === "year" && (
        <div className="m-2 p-text-date-year">
          <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
            <DatePicker
              views={["year"]}
              label="Año"
              openTo="year"
              name="fecha_desde"
              // minDate={new Date('2020-01-01')}
              value={filters.fecha_desde}
              onChange={handleChangeDateDesde}
              renderInput={(params) => (
                <TextField {...params} helperText={null} />
              )}
            />
          </LocalizationProvider>
        </div>
      )}

      {filters.time === "month" && (
        <div className="m-2 p-text-date-month">
          <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
            <DatePicker
              views={["year", "month"]}
              label="Mes"
              openTo="month"
              name="fecha_desde"
              // minDate={new Date('2020-01-01')}
              value={filters.fecha_desde}
              onChange={handleChangeDateDesde}
              renderInput={(params) => (
                <TextField {...params} helperText={null} />
              )}
            />
          </LocalizationProvider>
        </div>
      )}

      {filters.time === "range" && (
        <div className="m-2 text-start d-flex justify-content-start p-text-date-range">
          <span>
            <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
              <DatePicker
                views={["year", "month"]}
                label="Mes desde"
                openTo="month"
                name="fecha_desde"
                // minDate={new Date('2020-01-01')}
                value={filters.fecha_desde}
                onChange={handleChangeDateDesde}
                renderInput={(params) => (
                  <TextField {...params} helperText={null} />
                )}
              />
            </LocalizationProvider>
          </span>
          <span style={{ marginLeft: "10px" }}>
            <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
              <DatePicker
                views={["year", "month"]}
                label="Mes hasta"
                openTo="month"
                name="fecha_hasta"
                // minDate={new Date('2020-01-01')}
                value={filters.fecha_hasta}
                onChange={handleChangeDateHasta}
                renderInput={(params) => (
                  <TextField {...params} helperText={null} />
                )}
              />
            </LocalizationProvider>
          </span>
        </div>
      )}
    </>
  );
};
